




























import Vue from 'vue';
import { mapGetters } from 'vuex';
import Header from '@/components/Header.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import Pagination from '@/components/Pagination.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import ExamModeCard from '@/components/cards/ExamModeCard.vue';

export default Vue.extend({
  components: {
    Header,
    pxButton,
    Pagination,
    Loading,
    ExamModeCard,
  },
  data() {
    return {
      currentPage: 0,
      loaded: true,
    };
  },
  computed: {
    ...mapGetters({
      allExamModes: 'allExamModes',
    }),
  },
  mounted: async function() {
    const page = parseInt(this.$route.params.page);
    if (page > 0) {
      this.currentPage = page - 1;
    } else {
      this.$router.replace(`/formatos`);
    }
    this.loaded = false;
    try {
      await this.$store.dispatch('PULL_EXAM_MODES', {
        page: this.currentPage,
        size: 50,
      });
    } catch (e) {
      alert(
        `Algo deu errado. Envie essas informações para os desenvolvedores: ${e}`,
      );
    }
    this.loaded = true;
  },
  methods: {
    changePage: async function(event: number) {
      this.currentPage = event;
      this.loaded = false;
      await this.$store.dispatch('PULL_EXAM_MODES', {
        page: this.currentPage,
        size: 50,
      });
      this.loaded = true;
      this.$router.push(`/formatos/${this.currentPage + 1}`);
    },
  },
});
